import loadable from '@loadable/component';

import { IRoute } from '../interfaces/routing';

const Room = loadable(() => import('../pages/components/Room/Room'));
const ChangePasswordPage = loadable(
  () => import('../pages/dashboards/ClientDashboards/ChangePassword/ChangePasswordPage')
);
const AddClientComplaintPage = loadable(
  () => import('../pages/dashboards/ClientDashboards/Complaint/AddClientComplaintPage')
);
const ViewClientComplaintAgainstPage = loadable(
  () => import('../pages/dashboards/ClientDashboards/Complaint/ViewClientComplaintAgainstPage')
);
const ViewClientComplaintPage = loadable(
  () => import('../pages/dashboards/ClientDashboards/Complaint/ViewClientComplaintPage')
);
const Favorite = loadable(() => import('../pages/dashboards/ClientDashboards/Favorites/Favorite'));
const ConsentFormDoc = loadable(
  () => import('../pages/dashboards/ClientDashboards/GeneralInfomation/ConsentFormDoc')
);
const GeneralInfo = loadable(
  () => import('../pages/dashboards/ClientDashboards/GeneralInfomation/GeneralInfo')
);
const HealthAssessmentDoc = loadable(
  () => import('../pages/dashboards/ClientDashboards/GeneralInfomation/HealthAssessmentDoc')
);
const HealthAssesment = loadable(
  () => import('../pages/dashboards/ClientDashboards/HealthAssesment/HealthAssesment')
);
const ClientMyBookingPage = loadable(
  () => import('../pages/dashboards/ClientDashboards/MyBooking/ClientMyBooking')
);
const ClientDashboardPage = loadable(() => import('../pages/dashboards/dashboard/ClientDashboard'));

export const clientRoutes: IRoute[] = [
  {
    path: 'dashboard',
    component: ClientDashboardPage
  },
  {
    path: 'favorite',
    component: Favorite
  },
  {
    path: 'my-booking',
    component: ClientMyBookingPage
  },
  {
    path: 'room/:roomid',
    component: Room
  },
  {
    path: 'add-complaint',
    component: AddClientComplaintPage
  },
  {
    path: 'view-complaint-by-me',
    component: ViewClientComplaintPage
  },
  {
    path: 'view-complaint-against',
    component: ViewClientComplaintAgainstPage
  },
  {
    path: 'general-info',
    component: GeneralInfo
  },
  {
    path: 'consent-form-doc',
    component: ConsentFormDoc
  },
  {
    path: 'health-assessment-doc',
    component: HealthAssessmentDoc
  },
  {
    path: 'change-password',
    component: ChangePasswordPage
  },
  {
    path: 'health-assesment',
    component: HealthAssesment
  }
];
